import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Message, SelectItem } from 'primeng/api';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { PlanoContaEmpresa } from 'src/app/admihair/api/dto/plano-conta-empresa.';
import { PlanoContaGrupo } from 'src/app/admihair/api/dto/plano-conta-grupo';
import { PlanoContaMatriz } from 'src/app/admihair/api/dto/plano-conta-matriz';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { PlanoContaEmpresaService } from 'src/app/admihair/service/plano-conta-empresa.service';
import { PlanoContaGrupoService } from 'src/app/admihair/service/plano-conta-grupo.service';
import { PlanoContaMatrizService } from 'src/app/admihair/service/plano-conta-matriz.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-plano-contas-empresa-inserir',
  templateUrl: './plano-contas-empresa-inserir.component.html',
  styleUrls: ['./plano-contas-empresa-inserir.component.scss']
})
export class PlanoContasEmpresaInserirComponent implements OnInit {

  @ViewChild('f') form?: NgForm;
  permissaoInserir: boolean = false;
  messages: Message[] = []; 
  messagemVisivel: boolean = false;
  prioridades: SelectItem[] = [{label: 'SIM', value: 1}, {label: 'NÃO', value: 0}];
  dadosDre: string[] = ['CUSTOS FIXOS', 'CUSTOS VARIAVEIS', 'NÃO PRESENTE'];
  progressoRequisicao: boolean = false;
  mostrarDialogConta: boolean = false;
  modoImportacao: boolean = false;

  empresaSelecionada?: Empresa;
  planosContaGrupos: PlanoContaGrupo[] = [];
  listaContaMatriz: PlanoContaMatriz[] = [];
  planoContaMatrizSelecionado?: PlanoContaMatriz;
  planoContaEmpresa?: PlanoContaEmpresa;

  constructor(private utilStorageService: UtilStorageService,
    private planoContaEmpresaService: PlanoContaEmpresaService,
    private planoContaGrupoService: PlanoContaGrupoService,
    private planoContaMatrizService: PlanoContaMatrizService,
    private erroService: ErroService) { }



  ngOnInit(): void {
    this.permissaoInserir = AuthUtil.verificarPermissao('PERM_INSERIR_PLANO_CONTAS_EMPRESA');
    this.empresaSelecionada = this.utilStorageService.getEmpresa();
    if (this.permissaoInserir) {
      this.listarPlanosContaGrupos();
    }
  }

  salvar(){
    this.progressoRequisicao =true;
    let planoContaEmpresa: PlanoContaEmpresa = this.form?.value;

    planoContaEmpresa.empresa = this.empresaSelecionada;
    planoContaEmpresa.excluido = false;
    planoContaEmpresa.configuravel = true;
    planoContaEmpresa.ativo = true;
    
    if(this.modoImportacao){
      planoContaEmpresa.codigo = this.planoContaMatrizSelecionado?.id;
      planoContaEmpresa.utilizacao = this.planoContaMatrizSelecionado?.utilizacao;
      planoContaEmpresa.patrimonial = this.planoContaMatrizSelecionado?.patrimonial;
      planoContaEmpresa.referenciaFolha = this.planoContaMatrizSelecionado?.referenciaFolha;
      this.planoContaEmpresaService.salvarImportado(planoContaEmpresa).subscribe({
        next: (data: PlanoContaEmpresa) => {
          this.progressoRequisicao = false;
          this.form?.reset();
          this.modoImportacao = false;
          this.messages = this.erroService.handleSuccess();
          this.messagemVisivel = true;
          this.rolarTela();
        },
        error: (err: any) => {
          this.progressoRequisicao = false;
          this.messages = this.erroService.handleErro(err);
          this.messagemVisivel = true;
          this.rolarTela();
        }
      });
    } else {
      this.planoContaEmpresaService.salvar(planoContaEmpresa).subscribe({
        next: (data: PlanoContaEmpresa) => {
          this.progressoRequisicao = false;
          this.form?.reset();
          this.messages = this.erroService.handleSuccess();
          this.messagemVisivel = true;
          this.rolarTela();
        },
        error: (err: any) => {
          this.progressoRequisicao = false;
          this.messages = this.erroService.handleErro(err);
          this.messagemVisivel = true;
          this.rolarTela();
        }
      });
    }

  }

  listarPlanosContaGrupos(){
    this.planoContaGrupoService.listarConfiguraveis().subscribe({
      next: (data: PlanoContaGrupo[]) => {
        this.planosContaGrupos = data;
      },
      error: (err: any) => {
        console.log(err);
      }
    })
  }

  carregarPlanosContaMatriz(){
    this.planoContaMatrizService.listarNaoUtilizadosPorEmpresa(this.empresaSelecionada?.id).subscribe({
      next: (data: PlanoContaMatriz[]) => {
        this.listaContaMatriz = data;
      },
      error: (err: any) => {
        console.log(err);
      }
    })
  }

  importarConta(item: PlanoContaMatriz){
    console.log(item)
    this.form?.setValue({
      descricao: item.descricao,
      especificacao: item.especificacao,
      dre: item.dre,
      planoContaGrupo: item.planoContaGrupo
    });
    this.planoContaMatrizSelecionado = item;
    this.modoImportacao = true;
    this.mostrarDialogConta = false;
  }

  abrirDialogConta(){
    this.planoContaMatrizSelecionado = undefined;
    this.mostrarDialogConta = true;
    this.carregarPlanosContaMatriz();
  }

  fecharDialogConta(){
    this.mostrarDialogConta = false;
  }

  

  limparFormulario(){
    this.form?.reset(); 
  }

  rolarTela() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

}
